<template>
  <IconsPagesPlanning
    v-if="icon.includes('pages-planning')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
  <IconsPagesHR
    v-else-if="icon.includes('pages-hr')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
  <IconsPagesFinance
    v-else-if="icon.includes('pages-finance')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
  <IconsPagesProjects
    v-else-if="icon.includes('pages-projects')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
  <svg
    v-else-if="icon === 'pages-clients'"
    :width="width ? width : 23"
    :height="height ? height : 24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91664 13.9587C8.05537 17.3299 9.36897 20.2879 11.083 23.1885C12.9215 20.2889 14.1731 17.2643 14.289 13.8235C15.5426 14.6259 17.0132 14.693 18.3751 15.1097C19.1455 15.3455 19.8884 15.6387 20.5577 16.0971C21.4902 16.7358 22.0766 17.5951 22.1193 18.7395C22.1442 19.4189 22.0801 20.1029 22.0319 20.7828C22.008 21.1111 21.8169 21.3545 21.5344 21.5359C20.4357 22.2407 19.2304 22.696 17.9884 23.0604C15.3775 23.8282 12.7035 24.0823 9.99451 23.9751C7.1173 23.8582 4.33207 23.3069 1.69979 22.1005C1.28716 21.9114 0.899434 21.667 0.498494 21.4516C0.255593 21.321 0.130077 21.1192 0.0919648 20.8489C-0.0334851 19.9948 -0.0305742 19.1267 0.100603 18.2735C0.226627 17.4787 0.731232 16.9213 1.30291 16.4223C2.07735 15.7474 3.01745 15.3866 3.98855 15.1143C4.98709 14.8333 5.99477 14.5832 6.99382 14.3012C7.30786 14.2148 7.60615 14.0761 7.91664 13.9587Z"
      :fill="color"
    />
    <path
      d="M16.156 6.30833C16.3826 6.25751 16.4644 6.43689 16.4609 6.66404C16.4558 7.55637 16.3084 8.38671 15.4557 8.90554C15.3871 8.94721 15.3419 9.06409 15.3272 9.15353C15.1539 10.1968 14.819 11.1755 14.2661 12.0861C12.7838 14.5253 9.46348 14.4145 7.97253 12.233C7.36782 11.3437 6.95469 10.3884 6.7748 9.33138C6.74762 9.1427 6.64948 8.97149 6.50039 8.85269C5.86519 8.3054 5.55572 7.59093 5.53488 6.75551C5.52726 6.45061 5.56385 6.43079 6.01306 6.34898C5.95412 5.83167 5.87281 5.31538 5.83978 4.79553C5.76762 3.67351 5.93735 2.60179 6.61168 1.66271C7.23418 0.798834 8.1326 0.375026 9.13876 0.149402C10.6246 -0.183952 12.0231 0.0477706 13.3311 0.827291C13.393 0.869554 13.4618 0.900839 13.5344 0.919776C14.974 1.19977 15.7347 2.14445 16.0482 3.5114C16.1142 3.83385 16.1482 4.16202 16.1499 4.49114C16.1671 5.09331 16.156 5.70006 16.156 6.30833Z"
      :fill="color"
    />
    <path
      d="M11.0485 21.6116C10.6821 20.8174 10.3086 20.0267 9.95643 19.2263C9.90917 19.1191 9.95643 18.9621 9.98235 18.8325C10.0962 18.2461 10.2217 17.6637 10.335 17.0758C10.366 16.9142 10.4448 16.844 10.6084 16.8461C10.9712 16.8507 11.3346 16.8522 11.6974 16.8461C11.8651 16.8425 11.9428 16.9182 11.9749 17.0737C12.0999 17.6749 12.2289 18.2755 12.3529 18.8767C12.3694 18.9403 12.3667 19.0072 12.3453 19.0693C11.9586 19.9189 11.5663 20.7661 11.1765 21.6132L11.0485 21.6116Z"
      :fill="color"
    />
    <path
      d="M11.1374 14.7149C11.3569 14.7149 11.5764 14.7149 11.798 14.7149C12.1252 14.7184 12.268 14.8592 12.2299 15.1854C12.2029 15.4534 12.1476 15.7178 12.0648 15.9741C11.9586 16.2841 11.6857 16.3898 11.3793 16.3974C11.1683 16.4003 10.9573 16.3925 10.7471 16.374C10.4422 16.3512 10.2242 16.1708 10.1526 15.8765C10.0967 15.6479 10.0545 15.4156 10.0159 15.1834C9.97013 14.9115 10.1261 14.7301 10.4051 14.7164C10.4219 14.7164 10.4392 14.7164 10.4559 14.7164H11.1394L11.1374 14.7149Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-documents'"
    :width="width || 24"
    :height="height || 22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.4607 18.2965L22.0424 20.3463C21.8943 21.0717 21.2563 21.5927 20.5159 21.5927H2.44696C1.46132 21.5927 0.723451 20.689 0.920458 19.7233L2.65814 11.2068C2.77943 10.6126 3.2127 10.1496 3.76568 9.97141C3.80505 9.95869 3.84516 9.94742 3.88562 9.93761C3.88768 9.93713 3.88974 9.93676 3.8918 9.93628C3.92985 9.92719 3.96826 9.91931 4.00715 9.91289C4.01939 9.91095 4.03174 9.90974 4.0441 9.90805C4.07403 9.90381 4.10408 9.89957 4.13449 9.89702C4.17908 9.89339 4.22403 9.89108 4.26946 9.89108H4.97728H19.2421H20.4537H22.4605H23.2161C23.433 9.89108 23.626 9.97808 23.7662 10.1166C23.9063 10.2551 23.9938 10.4452 23.9995 10.6514C24.0011 10.7103 23.9961 10.7705 23.9838 10.8312L22.4607 18.2965ZM22.4529 8.67948C22.3802 7.98729 21.7932 7.44594 21.0821 7.44594H20.4537V8.67948H22.4529ZM1.47113 10.9646C1.70703 9.80833 2.63464 8.92919 3.7658 8.72479V5.38754H1.6175C0.725632 5.38754 0 6.11317 0 7.00491V18.1741L1.47113 10.9646ZM19.2421 1.08767V8.67948H4.9774V1.08767C4.9774 0.712674 5.28261 0.407471 5.6576 0.407471H18.5621C18.9371 0.407471 19.2421 0.712553 19.2421 1.08767ZM17.4986 6.4523C17.4986 6.11778 17.2275 5.8465 16.8928 5.8465H7.32671C6.99219 5.8465 6.72091 6.11778 6.72091 6.4523C6.72091 6.78683 6.99219 7.0581 7.32671 7.0581H16.8928C17.2275 7.0581 17.4986 6.78683 17.4986 6.4523ZM17.4986 3.32429C17.4986 2.98977 17.2275 2.71849 16.8928 2.71849H7.32671C6.99219 2.71849 6.72091 2.98977 6.72091 3.32429C6.72091 3.65882 6.99219 3.9301 7.32671 3.9301H16.8928C17.2275 3.9301 17.4986 3.65882 17.4986 3.32429Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-documents-personal'"
    :width="width || 19"
    :height="height || 22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0.5V5.75C11 6.34674 11.2371 6.91903 11.659 7.34099C12.081 7.76295 12.6533 8 13.25 8H18.5V19.25C18.5 19.8467 18.2629 20.419 17.841 20.841C17.419 21.2629 16.8467 21.5 16.25 21.5H10.715L10.742 21.4775C11.2934 21.0257 11.7373 20.4568 12.0414 19.812C12.3455 19.1673 12.5022 18.4629 12.5 17.75C12.5001 16.8143 12.1504 15.9124 11.5196 15.2213C10.8887 14.5302 10.0223 14.1 9.0905 14.015C9.80971 13.2194 10.2211 12.1932 10.2507 11.1211C10.2802 10.049 9.92583 9.00167 9.25148 8.16774C8.57713 7.33381 7.62712 6.76813 6.57261 6.57264C5.51811 6.37715 4.42846 6.5647 3.5 7.1015V2.75C3.5 2.15326 3.73705 1.58097 4.15901 1.15901C4.58097 0.737053 5.15326 0.5 5.75 0.5H11ZM12.5 0.875V5.75C12.5 5.94891 12.579 6.13968 12.7197 6.28033C12.8603 6.42098 13.0511 6.5 13.25 6.5H18.125L12.5 0.875ZM8.75 11C8.75 11.7956 8.43393 12.5587 7.87132 13.1213C7.30871 13.6839 6.54565 14 5.75 14C4.95435 14 4.19129 13.6839 3.62868 13.1213C3.06607 12.5587 2.75 11.7956 2.75 11C2.75 10.2044 3.06607 9.44129 3.62868 8.87868C4.19129 8.31607 4.95435 8 5.75 8C6.54565 8 7.30871 8.31607 7.87132 8.87868C8.43393 9.44129 8.75 10.2044 8.75 11V11ZM11 17.75C11 19.6175 9.5 21.5 5.75 21.5C2 21.5 0.5 19.625 0.5 17.75C0.5 17.1533 0.737053 16.581 1.15901 16.159C1.58097 15.7371 2.15326 15.5 2.75 15.5H8.75C9.34674 15.5 9.91903 15.7371 10.341 16.159C10.7629 16.581 11 17.1533 11 17.75V17.75Z"
      :fill="color"
    />
  </svg>
  <svg
    v-else-if="icon === 'pages-documents-all'"
    :width="width || 18"
    :height="height || 24"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.07692 24H15.9231C17.0683 24 18 23.0538 18 21.8906V7.03125H13.1538C12.0086 7.03125 11.0769 6.08503 11.0769 4.92188V0H2.07692C0.931662 0 0 0.946219 0 2.10938V21.8906C0 23.0538 0.931662 24 2.07692 24ZM4.84615 9.89062H13.1538C13.5365 9.89062 13.8462 10.2051 13.8462 10.5938C13.8462 10.9824 13.5365 11.2969 13.1538 11.2969H4.84615C4.46349 11.2969 4.15385 10.9824 4.15385 10.5938C4.15385 10.2051 4.46349 9.89062 4.84615 9.89062ZM4.84615 12.7031H13.1538C13.5365 12.7031 13.8462 13.0176 13.8462 13.4062C13.8462 13.7949 13.5365 14.1094 13.1538 14.1094H4.84615C4.46349 14.1094 4.15385 13.7949 4.15385 13.4062C4.15385 13.0176 4.46349 12.7031 4.84615 12.7031ZM4.84615 15.5156H13.1538C13.5365 15.5156 13.8462 15.8301 13.8462 16.2188C13.8462 16.6074 13.5365 16.9219 13.1538 16.9219H4.84615C4.46349 16.9219 4.15385 16.6074 4.15385 16.2188C4.15385 15.8301 4.46349 15.5156 4.84615 15.5156ZM4.84615 18.3281H10.3846C10.7673 18.3281 11.0769 18.6426 11.0769 19.0312C11.0769 19.4199 10.7673 19.7344 10.3846 19.7344H4.84615C4.46349 19.7344 4.15385 19.4199 4.15385 19.0312C4.15385 18.6426 4.46349 18.3281 4.84615 18.3281Z"
      :fill="color"
    />
    <path
      d="M13.1542 5.62317H17.5947L12.4619 0.410156V4.92005C12.4619 5.30798 12.7723 5.62317 13.1542 5.62317Z"
      :fill="color"
    />
  </svg>
  <IconsPagesSettings
    v-else-if="icon.includes('pages-settings')"
    :icon="icon"
    :color="color"
    :width="width"
    :height="height"
  />
</template>

<script>
import IconsPagesPlanning from 'components/icons/pages/IconsPagesPlanning'
import IconsPagesHR from 'components/icons/pages/IconsPagesHR'
import IconsPagesProjects from 'components/icons/pages/IconsPagesProjects'
import IconsPagesSettings from 'components/icons/pages/IconsPagesSettings'
import IconsPagesFinance from './IconsPagesFinance'

export default {
  name: 'IconsPages',
  props: {
    icon: String,
    color: {
      type: String,
      default: '#A2D5F1',
    },
    width: {
      type: [String, Number],
      default: null,
    },
    height: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    IconsPagesFinance,
    IconsPagesPlanning,
    IconsPagesHR,
    IconsPagesProjects,
    IconsPagesSettings,
  },
}
</script>

<style scoped></style>
